import React from 'react';
import T from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { LocalNavigation, unit } from '@acast/decibel';
import { ThLightGlyph, CogRegularGlyph } from '@acast/decibel-glyphs';
import SelectShowItem from '../../app/navigation/SelectShowItem';
import InsightsItem from '../../app/navigation/InsightsItem';
import navigateTo from '../../../shared/helpers/navigate-to';
import { reactRouterLocationPropType, showPropType } from '../../../customPropTypes';
import NewEpisodeButton from '../show-episodes-page/components/new-episode-button';
import { selectShow } from '../../../ducks/shows';
import isShowValid from '../../../validation/show';

const NewEpisodeButtonItem = styled.div`
  margin-left: ${unit(2)};
`;

const isSelectedPath = (location, path) => {
  return location.pathname.includes(path) || undefined;
};

const navigatePath = (params, path) => {
  const { showId } = params;
  return `/shows/${showId}${path}`;
};

const Navigation = ({ location, params, show }) => {
  return (
    <LocalNavigation>
      <LocalNavigation.Column>
        <LocalNavigation.Item
          glyph={ThLightGlyph}
          onClick={() => navigateTo(navigatePath(params, '/episodes'))}
          selected={isSelectedPath(location, '/episodes')}
        >
          Episodes
        </LocalNavigation.Item>
        <SelectShowItem />
      </LocalNavigation.Column>
      <LocalNavigation.Column align="right" stretch>
        <LocalNavigation.Item
          glyph={CogRegularGlyph}
          onClick={() => navigateTo(navigatePath(params, '/settings'))}
          selected={isSelectedPath(location, '/settings')}
        >
          Settings
        </LocalNavigation.Item>
        <InsightsItem showId={params.showId} />
        <NewEpisodeButtonItem>
          <NewEpisodeButton showId={params.showId} disabled={!isShowValid(show)} />
        </NewEpisodeButtonItem>
      </LocalNavigation.Column>
    </LocalNavigation>
  );
};

Navigation.propTypes = {
  params: T.shape({
    showId: T.string.isRequired,
  }).isRequired,
  location: reactRouterLocationPropType,
  show: showPropType,
};

const connectedNavigation = connect((state, { params }) => ({
  show: selectShow(params.showId)(state),
}))(Navigation);

export default withRouter(connectedNavigation);
